import { render } from "./khgl.vue?vue&type=template&id=6f14a8a0&scoped=true"
import script from "./khgl.vue?vue&type=script&lang=js"
export * from "./khgl.vue?vue&type=script&lang=js"

import "./khgl.vue?vue&type=style&index=0&id=6f14a8a0&scoped=true&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f14a8a0"]])

export default __exports__